<div class='delivery-engagements-page'>

	<toolbar icon='Delivery'>

		<button class="btn btn-light" (click)='deliveryService.reloadData()' KendoTooltip [attr.title]="'Reload'"><i class='far fa-sync-alt' style="display: inline-block;width: 1.5em;"></i></button>

		<droplist [items]='[]' [popupConfig]='popupConfig' [navigation]='true'>
		</droplist>

		<div style='display:inline-block;width:300px'>
			<trimester-droplist [trimesterWindow]="trimesterWindow"></trimester-droplist>
		</div>

	</toolbar>

	<page-tabs [tabNames]='["Engagements", "Tab1", "Tab2"]' [pageService]='pageService' (layoutChange)='onLayoutChange($event)'>
		<ng-template pageTab1>
			<delivery-engagements-views-part></delivery-engagements-views-part>
		</ng-template>

		<ng-template pageTab2>
			<delivery-engagements-tab-1-part></delivery-engagements-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<delivery-engagements-tab-2-part></delivery-engagements-tab-2-part>
		</ng-template>
	</page-tabs>

</div>